import { ApiRequest, RequestMethod } from "../../../request";
import { XpSourceDict } from "../../../../model/Dto/Dict/XpSource";

export async function getAllXpSources(): Promise<XpSourceDict[]> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.GET);
    apiRequest.setUrl("/api/xp-source");

    const response: any = await apiRequest.send();
    return response.status === 200 ? response.data : [];
}
